import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { RequestParams, ResponseCatalog } from 'Models'
import { CallStatus, CallModel, Status, PotentialClientStatus } from 'Pages/coliseum'

export const callApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<CallModel>>(urls.coliseum.call, { params })
		return res.data
	},

	createOne: async (data: any) => {
		const res = await axiosDS().post(urls.coliseum.call, { data })
		return res.data
	},

	updateOne: async (id: number, data: any) => {
		const res = await axiosDS().patch(`${urls.coliseum.call}/${id}`, { data })
		return res.data
	},

	getAllCallStatus: async () => {
		const res = await axiosDS().get<CallStatus[]>(urls.coliseum.callstatus)
		return res.data
	},
	getAllStatus: async () => {
		const res = await axiosDS().get<Status[]>(urls.coliseum.status)
		return res.data
	},

	getAllPotentialClientStatus: async () => {
		const res = await axiosDS().get<PotentialClientStatus[]>(urls.coliseum.potentialClientStatus)
		return res.data
	},
}
